import { IAssets } from '../models/assets';
import { initIProperty, IProperty } from '../models/property';
import { visitorSummary, visitorTable } from '../models/table/visitorTable';
import { Visitor } from '../models/visitor';

export function organizeVisitorTableData(datasource: Visitor[]) {
  const newDS: visitorTable[] = [];

  datasource.forEach((index) => {
    let tempDS: visitorTable = {
      name: '',
      date: null,
      time: null,
      host: '',
      purpose: '',
      security: null,
    };
    tempDS.name = index.firstName + ' ' + index.lastName;
    tempDS.date = new Date(index.visitDateTime);
    tempDS.time = new Date(index.visitDateTime);
    tempDS.host = index.hostName;
    tempDS.purpose =
      index.purpose.length == 0 ? 'Not Mentioned' : index.purpose;
    tempDS.security = index.securityStatus == 0 ? 'Unverified' : 'Verified';
    newDS.push(tempDS);
  });
  return newDS;
}
export function getSummaryOfVisitDate(datasource: Visitor[], todayDate: Date) {
  const newDS: visitorSummary[] = [];
  let presentDS: Visitor[] = [];
  let pastDS: Visitor[] = [];
  let futureDS: Visitor[] = [];
  console.log(todayDate);
  datasource.forEach((index) => {
    if (
      new Date(index.visitDateTime).toLocaleDateString() ===
      new Date(todayDate).toLocaleDateString()
    ) {
      presentDS.push(index);
    }
    if (
      new Date(index.visitDateTime).getTime() < new Date(todayDate).getTime()
    ) {
      pastDS.push(index);
    }
    if (
      new Date(index.visitDateTime).getTime() > new Date(todayDate).getTime()
    ) {
      futureDS.push(index);
    }
  });
  let temp: visitorSummary = {
    count: null,
    verified: null,
    unverified: null,
    visited: null,
    yetToVisit: null,
    visitedVerified: null,
    visitedUnverified: null,
    yetToVisitVerified: null,
    yetToVisitUnverified: null,
  };
  temp.count = presentDS.length;
  temp.verified = presentDS.filter((item) => item.securityStatus == 1).length;
  temp.unverified = presentDS.filter((item) => item.securityStatus == 0).length;
  temp.visited = pastDS.length;
  temp.yetToVisit = futureDS.length;
  temp.visitedVerified = pastDS.filter(
    (item) => item.securityStatus == 1
  ).length;
  temp.visitedUnverified = pastDS.filter(
    (item) => item.securityStatus == 0
  ).length;
  temp.yetToVisitVerified = futureDS.filter(
    (item) => item.securityStatus == 1
  ).length;
  temp.yetToVisitUnverified = futureDS.filter(
    (item) => item.securityStatus == 0
  ).length;

  return temp;
}
export function getSelectedDateVisitorTableData(
  date: Date,
  datasource: Visitor[]
) {
  if (date) {
    return datasource.filter(
      (data) =>
        new Date(data.visitDateTime + 'Z').toDateString() ===
        date.toDateString()
    );
  }
  return [];
}

export function getAllAssetsFromPropertyArray(property: IProperty[]) {
  const asset: IAssets[] = [];
  property.forEach((data) => {
    if (data.assetDetails && data.assetDetails.length > 0) {
      data.assetDetails.forEach((tempAsset) => {
        asset.push(tempAsset);
      });
    }
  });
  return asset;
}
export function getPropertyDetails(property: IProperty[], assetId: string) {
  let res: IProperty = initIProperty;
  property.forEach((data) => {
    if (data.assetDetails) {
      data.assetDetails.forEach((item) => {
        if (item.assetId === assetId) res = data;
      });
    }
  });
  return res;
}

// export function getSortedVisitorTableData(datasource: Visitor[]) {
//   if (datasource.length > 0)
//     datasource.sort((val1, val2) => {
//       return (
//         new Date(val1.visitDateTime).getTime() -
//         new Date(val2.visitDateTime).getTime()
//       );
//     });
// }
